import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import {
  useGetBankInfosQuery,
  useRemoveBankInfoMutation,
} from "../../../features/api/bankinfoApi";
import { toast } from "react-toastify";

const BankInfo = () => {
  const { data, error, isLoading } = useGetBankInfosQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const bankInfos = data?.bankinfos;

  const [removeBankInfo] = useRemoveBankInfoMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeBankInfo(id);
        if (result) {
          toast.success("Delete Success...!!!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);

    const filteredResults = bankInfos?.filter((item) =>
      item?.bankName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(filteredResults);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div>
      <div className="flex justify-between items-center px-12 my-4">
        <h1 className="text-xl font-bold">Bank Info</h1>
        <button className="px-2 py-1 bg-green-950 text-white font-bold rounded-sm">
          <Link to="/dashboard/bankinfo-create">Create</Link>
        </button>
      </div>
      <input
        type="text"
        placeholder="Search items"
        className="border ml-12 focus:outline-none h-8 rounded p-1"
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <div className="h-[75vh] overflow-auto max-w-sm lg:max-w-[960px] m-auto">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : bankInfos?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no Bank Information
          </p>
        ) : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Bank Name</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Branch Name</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Account Name</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Account No</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Routing Number</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Bank Location</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchTerm
                  ? searchResults
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row, i) => (
                        <TableRow key={row.id}>
                          <TableCell>{i + 1}</TableCell>
                          <TableCell>{row.bankName}</TableCell>
                          <TableCell>{row.branchName}</TableCell>
                          <TableCell>{row.accName}</TableCell>
                          <TableCell>{row.accNo}</TableCell>
                          <TableCell>{row.BraRouNum}</TableCell>
                          <TableCell>{row.BankLoct}</TableCell>
                          <TableCell className="">
                            <div className="flex items-center gap-x-4">
                              <span onClick={() => handleDelete(row?.id)}>
                                <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                              </span>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                  : bankInfos
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row, i) => (
                        <TableRow key={row.id}>
                          <TableCell>{i + 1}</TableCell>
                          <TableCell>{row.bankName}</TableCell>
                          <TableCell>{row.branchName}</TableCell>
                          <TableCell>{row.accName}</TableCell>
                          <TableCell>{row.accNo}</TableCell>
                          <TableCell>{row.BraRouNum}</TableCell>
                          <TableCell>{row.BankLoct}</TableCell>
                          <TableCell className="">
                            <div className="flex items-center gap-x-4">
                              <span onClick={() => handleDelete(row?.id)}>
                                <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                              </span>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={bankInfos?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default BankInfo;